import { render, staticRenderFns } from "./MonthlyTasks.vue?vue&type=template&id=66218a4c&"
import script from "./MonthlyTasks.vue?vue&type=script&lang=js&"
export * from "./MonthlyTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports